// @flow

const MAX_TEMPLATE_PRICE = 1000;

export const parseTemplateNamePrice = (templateName: string): ?number => {
  const normalizedName = templateName.trim();

  if (/\bFREE\b/i.test(normalizedName)) {
    return 0;
  }

  const dollarMatch = normalizedName.match(/\$(\d+(?:\.\d{1,2})?)\b/);

  if (!dollarMatch) {
    return null;
  }

  const price = parseFloat(dollarMatch[1]);

  return price >= 0 && price < MAX_TEMPLATE_PRICE ? price : null;
};
